
import { useAccessibleFocus } from '../composables/useAccessibleFocus';
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  Ref,
  watch
} from 'vue';
import BaseButton from './BaseButton.vue';

export default defineComponent({
  name: 'BaseToast',

  components: {
    BaseButton
  },

  props: {
    value: {
      type: Boolean,
      required: true
    }
  },

  setup(props, context) {
    const isMobile = window?.innerWidth < 480;
    const isVisible = computed((): boolean => {
      return props.value;
    });
    const toastActions: Ref<HTMLElement> = ref(null);
    const { setFocus, resetFocus } = useAccessibleFocus();

    const animationName = computed((): string => {
      // Disable animations in Cypress for percy
      if (typeof window !== 'undefined' && window.Cypress) {
        return '';
      }
      return 'fade';
    });

    function handleClose() {
      context.emit('input', false);
    }

    watch(isVisible, async () => {
      if (isVisible.value) {
        await setFocus(toastActions);
      } else {
        resetFocus();
      }
    });

    onMounted(async () => {
      if (isVisible.value) {
        await setFocus(toastActions);
      }
    });

    onBeforeUnmount(() => {
      resetFocus();
    });

    return {
      isVisible,
      animationName,
      isMobile,
      toastActions,
      handleClose
    };
  }
});
